<template>
  <v-container class="custom-container">
    <v-row dense>
      <v-col cols="12">
        <v-card class="pa-5" elevation="0" :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
          <v-row dense>
            <v-col :cols="$canRoute('leverage') !== 1 ? 12 : 10">
              <v-text-field v-model="search" prepend-icon="mdi-magnify" label="Search Leverage ..." single-line solo
                hide-details class="custom-v-input"></v-text-field>
            </v-col>
            <v-col cols="2" v-if="$canRoute('leverage') === 1">
              <v-dialog transition="scale-transition" origin="center center" max-width="324" v-model="dialog"
                content-class="deposit-withdraw-popup marketingPopup">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn large tile block elevation="0" class="ma-0 text-capitalize btn-account" color="greenMain"
                    height="48px" v-bind="attrs" v-on="on">
                    Add New
                  </v-btn>
                </template>

                <v-card class="rounded-0 pa-7" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
                  <v-card-title class="pb-3 text-left justify-start pl-3">
                    Add New Leverage
                  </v-card-title>
                  <v-card-subtitle class="mt-0 pl-3 pb-0 pr-10 text--ash">
                    You Can Add New Leverage From Here
                  </v-card-subtitle>
                  <v-card class="deposit-form px-3 py-4"
                    :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
                    <v-row>
                      <v-col cols="12">
                        <fieldset>
                          <legend>Leverage*</legend>
                          <v-select v-model="newleverage" :items="availableLeverageOptions" label="Select leverage" solo
                            hide-details class="custom-select"></v-select>
                          <span v-if="showErrors && !newleverage" style="color: red; font-size: 12px; margin-top: 1px">
                            Leverage field is required
                          </span>
                        </fieldset>
                      </v-col>
                    </v-row>
                  </v-card>
                  <v-card-actions>
                    <v-row dense>
                      <v-col cols="6">
                        <v-btn tile block elevation="0" class="text-capitalize btn-account" color="greenMain"
                          @click.prevent="createLeverage">
                          Save
                        </v-btn>
                      </v-col>
                      <v-col cols="6">
                        <v-btn tile block color="#FF567F" @click="closeDialog" elevation="0"
                          class="text-capitalize btn-account">
                          Close
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="12">
              <v-card class="pa-3 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#172233' : '#E8F1F8'">
                <v-sheet class="transactionTable depositTabTable" :color="$vuetify.theme.dark ? '#1A2A3E ' : '#F1F7FB'">
                  <v-data-table :headers="headers" :items="leverages" :search="search" :items-per-page="10">
                    <template v-slot:item.sl="{ item, index }">
                      {{ index + 1 }}
                    </template>
                    <template v-slot:item.leverage="{ item }">
                      {{ 1 + ":" + item?.leverage }}
                    </template>
                    <template v-slot:item.details="{ item }" v-if="$canRoute('leverage') === 1">
                      <v-dialog v-model="deleteLeverageModal[item.id]" max-width="400" class="rounded-0">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon color="#FF567F" small v-bind="attrs" v-on="on">
                            mdi-trash-can-outline
                          </v-icon>
                        </template>
                        <v-card rounded="0" width="400" class="auth-modal-card"
                          :color="$vuetify.theme.dark ? '#111A26' : '#ffffff'">
                          <v-card-title class="px-0 pt-0"> Delete? </v-card-title>
                          <v-card-text class="px-0">Do you want to delete?</v-card-text>
                          <v-card-actions class="px-0 pb-0">
                            <v-btn class="elevation-0" :color="$vuetify.theme.dark ? '#FF567F' : '#FF567F'"
                              @click="deleteLeverage(item?.id); this.$set(deleteLeverageModal, item.id, false);">
                              Delete
                            </v-btn>
                            <v-btn class="elevation-0" :color="$vuetify.theme.dark ? '#111A26' : '#ffffff'" outlined
                              @click="closeLeverageDialog(item)">
                              Cancel
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </template>
                     <template v-slot:item.details="{ item }" v-else>
                      ...
                     </template>
                  </v-data-table>
                </v-sheet>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { LEVERAGE__ACTIONS } from "@/store/action-types";

export default {
  data() {
    return {
      deleteLeverageModal: {},
      dialog: false,
      search: "",
      headers: [
        { text: "SL", value: "sl", align: "start" },
        { text: "Leverage", value: "leverage" },
        { text: "Action", value: "details" },
      ],
      newleverage: "",
      showErrors: false,
      leverageOptions: [
        { text: '1:1', value: '1' },
        { text: '1:2', value: '2' },
        { text: '1:3', value: '3' },
        { text: '1:5', value: '5' },
        { text: '1:10', value: '10' },
        { text: '1:15', value: '15' },
        { text: '1:20', value: '20' },
        { text: '1:25', value: '25' },
        { text: '1:33', value: '33' },
        { text: '1:40', value: '40' },
        { text: '1:50', value: '50' },
        { text: '1:66', value: '66' },
        { text: '1:75', value: '75' },
        { text: '1:80', value: '80' },
        { text: '1:100', value: '100' },
        { text: '1:125', value: '125' },
        { text: '1:150', value: '150' },
        { text: '1:175', value: '175' },
        { text: '1:200', value: '200' },
        { text: '1:300', value: '300' },
        { text: '1:400', value: '400' },
        { text: '1:500', value: '500' },
        { text: '1:1000', value: '1000' },
        { text: '1:5000', value: '5000' }
      ]
    };
  },

  computed: {
    ...mapState("leverage", ["leverages"]),
    ...mapState("admins", ["loggedAdmin"]),

    availableLeverageOptions() {
      const selectedLeverages = new Set(this.leverages.map(l => l.leverage.toString()));
      return this.leverageOptions.filter(option => !selectedLeverages.has(option.value));
    }
  },

  methods: {
    ...mapActions("leverage", [
      LEVERAGE__ACTIONS.LEVERAGE,
      LEVERAGE__ACTIONS.CREATELEVERAGE,
      LEVERAGE__ACTIONS.DELETELEVERAGE,
    ]),

    closeLeverageDialog(item) {
      this.$set(this.deleteLeverageModal, item.id, false);
    },

    closeDialog() {
      this.dialog = false;
      this.newleverage = "";
      this.showErrors = false;
    },

    async createLeverage() {
      this.showErrors = true;
      if (this.newleverage) {
        try {
          await this[LEVERAGE__ACTIONS.CREATELEVERAGE]({
            leverage: this.newleverage,
          });
          this.closeDialog();
        } catch (error) {
          console.error("Error creating leverage:", error);
        }
      }
    },

    async deleteLeverage(id) {
      try {
        await this[LEVERAGE__ACTIONS.DELETELEVERAGE]({ id });
      } catch (error) {
        console.error("Error deleting leverage:", error);
      }
    },
  },

  async created() {
    await this[LEVERAGE__ACTIONS.LEVERAGE]();
  },
};
</script>